import FormGroup from "legacy/FormGroup"
import {
  afterSetState,
  buildRoute,
  centsToDollars,
  dollarsToCents,
  handleInputChange,
  objectKeysToSnakeCase,
  parseJSONError,
} from "legacy/helpers.es6"
import RateModal from "legacy/manage/RateModal"
import Availability from "legacy/new-reservation-form/Availability"
import DiscountSection from "legacy/new-reservation-form/DiscountSection"
import ItinerarySection from "legacy/new-reservation-form/ItinerarySection"
import PaymentDetailsSection from "legacy/new-reservation-form/PaymentDetailsSection"
import PricingSection from "legacy/new-reservation-form/PricingSection"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally, not via an import
// Note: $context is a global object containing configuration and context values
// Note: Amplitude is loaded globally, not via an import

class Summary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      electricId: this.props.electricId || undefined,
      arrival: this.props.arrival,
      departure: this.props.departure || undefined,
      spaceType: this.props.spaceType,
      billingCycle: this.props.billingCycle,
      paymentMethod: this.props.paymentMethod,
      confirmationEmail: this.props.confirmationEmail,
      discounts: this.props.discounts || [],
      promoCodes: [],
      userCards: [],
      selectedCardId: "add_new_card",
      rate: this.props.rate,
      rateType: this.props.rateType,
      customBilling: this.props.customBilling,
      isCustomBillingSet: this.props.isCustomBillingSet,
      isRateApplied: this.props.isRateApplied,
      loadingPrice: false,
      totalPrice: this.props.totalPrice,
      charges: this.props.charges,
      availabilityData: null,
      showPromoCodes: false,
      revenueCategories: this.props.revenueCategories,
      preservedRates: [],
    }
    this.validator = validatorFactory()
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleArrivalChange = this.handleArrivalChange.bind(this)
    this.handleDepartureChange = this.handleDepartureChange.bind(this)
    this.handleInputChangeNoReload = this.handleInputChangeNoReload.bind(this)
    this.handleCouponCode = this.handleCouponCode.bind(this)
    this.showCouponCode = this.showCouponCode.bind(this)
    this.updateParent = this.updateParent.bind(this)
    this.updateStateFromRate = this.updateStateFromRate.bind(this)
    this.addDiscountToForm = this.addDiscountToForm.bind(this)
    this.removeDiscount = this.removeDiscount.bind(this)
    this.setStripeCard = this.setStripeCard.bind(this)
    this.isMonthToMonth = this.isMonthToMonth.bind(this)
    this.submitReservation = this.submitReservation.bind(this)
    this.getCreditCards = this.getCreditCards.bind(this)
    this.getDiscounts = this.getDiscounts.bind(this)
    this.getAvailability = this.getAvailability.bind(this)
    this.promoCodesAvailable = this.promoCodesAvailable.bind(this)
    this.calculatePrice = this.calculatePrice.bind(this)
    this.spaceCategory = this.spaceCategory.bind(this)
    this.createReservation = this.createReservation.bind(this)
    this.cardId = this.cardId.bind(this)
    this.creditCard = this.creditCard.bind(this)
    this.savedOrCustomRateApplied = this.savedOrCustomRateApplied.bind(this)
    this.fireAmplitudeRevenueCategory =
      this.fireAmplitudeRevenueCategory.bind(this)
    this.renderRevenueCategoryChooser =
      this.renderRevenueCategoryChooser.bind(this)
    this.couponCodeSection = this.couponCodeSection.bind(this)
    this.boatTypeIcon = this.boatTypeIcon.bind(this)
    this.electricSelect = this.electricSelect.bind(this)
    this.calculatePriceParams = this.calculatePriceParams.bind(this)
  }

  componentDidMount() {
    this.updateParent()
    this.calculatePrice()
    this.getCreditCards()
    this.getDiscounts()
  }

  handleInputChange(e) {
    handleInputChange(this, e)
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  handleArrivalChange(date) {
    this.setState({ arrival: moment(date, "MM/DD/YYYY").format("YYYY-MM-DD") })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
    afterSetState(this.getDiscounts)
  }

  handleDepartureChange(date) {
    this.setState({
      departure: moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
    })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
    afterSetState(this.getDiscounts)
  }

  handleCouponCode(event) {
    this.setState({ promoCode: event.target.value })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  handleInputChangeNoReload(e) {
    handleInputChange(this, e)
    afterSetState(this.updateParent)
  }

  updateParent(skipReload = false) {
    this.props.updateParentState(
      {
        rate: this.state.rate,
        customBilling: this.state.customBilling,
        isRateApplied: this.state.isRateApplied,
        isCustomBillingSet: this.state.isCustomBillingSet,
        electricId: this.state.electricId,
        arrival: this.state.arrival,
        departure: this.state.departure,
        spaceType: this.state.spaceType,
        billingCycle: this.state.billingCycle,
        paymentMethod: this.state.paymentMethod,
        confirmationEmail: this.state.confirmationEmail,
        selectedCardId: this.state.selectedCardId,
        discounts: this.state.discounts,
      },
      skipReload
    )
  }

  updateStateFromRate(state) {
    // Moving to a nightly rate, we need to make sure the space type is one that exists for nightly rates
    let spaceType = this.state.spaceType
    if (state.rateType === "nightly" && this.state.rateType !== "nightly") {
      if (!this.props.marina.spaceTypes.includes(spaceType)) {
        spaceType = this.props.marina.spaceTypes[0]
      }
    }
    this.setState({
      customBilling: { ...this.state.customBilling, ...state.customBilling },
      rate: { ...this.state.rate, ...state },
      spaceType,
      ...state,
    })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  spaceCategory() {
    if (this.state.spaceType === "Mooring") {
      return "moorage"
    } else {
      return "dockage"
    }
  }

  getCreditCards() {
    if (this.props.contact && this.state.userCards.length === 0) {
      $.get(
        `${$context.managePath}/contacts/${this.props.contact.encodedId}/cards`,
        (data) => {
          if (this.state.selectedCardId === "add_new_card" && data.length > 0) {
            this.setState({
              userCards: data,
              selectedCardId: data[0].stripePaymentMethodId,
            })
          } else {
            this.setState({ userCards: data })
          }
        },
        "json"
      )
    }
  }

  getDiscounts() {
    if (this.props.contact && this.state.arrival && this.state.departure) {
      const params = {
        arrival: this.state.arrival,
        departure: this.state.departure,
        contact_id: this.props.contact.encodedId,
        space_type: this.state.spaceType,
      }
      $.get(
        `${$context.managePath}/reservations/discounts`,
        params,
        (data) => {
          const oldDiscounts = this.state.discounts
          const updateToDiscounts =
            oldDiscounts.length === 0 ? data.discounts : oldDiscounts
          const oldPromoCodes = this.state.promoCodes
          const updateToPromoCodes =
            oldPromoCodes.length === 0 ? data.promoCodes : oldPromoCodes

          this.setState({
            discounts: updateToDiscounts,
            promoCodes: updateToPromoCodes,
          })
        },
        "json"
      )
    }
  }

  getAvailability() {
    if (this.state.arrival && this.state.departure) {
      const availabilityParams = {
        check_in_date: this.state.arrival,
        check_out_date: this.state.departure,
        requested_space_type: this.state.spaceType,
      }
      this.setState({ loadingAvailability: true })
      $.post($context.availabilityPath, availabilityParams, (data) => {
        this.setState({ loadingAvailability: false, availabilityData: data })
      }).fail((data) => {
        this.setState({ loadingAvailability: false })
      })
    }
  }

  calculatePriceParams() {
    const params = {
      check_in_date: this.state.arrival,
      check_out_date: this.state.departure,
      requested_space_type: this.state.spaceType,
      contact_id: this.props.contact.id,
      contact_boat_id: this.props.boat.id,
    }
    if (this.state.promoCode) {
      params.promo_code_id = this.state.promoCode
    }
    if (this.props.savedOrCustomRateApplied) {
      const rateParams = {
        ...this.state.rate,
        amount: dollarsToCents(parseFloat(this.state.rate.amount)),
        taxRate: this.state.rate.taxRate
          ? parseFloat(this.state.rate.taxRate) / 100
          : 0.0,
        feesAndDiscounts: this.state.rate.feesAndDiscounts
          ? JSON.stringify(this.state.rate.feesAndDiscounts)
          : [],
      }
      params.rate = _.mapKeys(rateParams, objectKeysToSnakeCase)
      if (this.state.isCustomBillingSet) {
        params.custom_billing = _.mapKeys(
          this.state.customBilling,
          objectKeysToSnakeCase
        )
      }
    } else {
      params.billing_cycle = this.state.billingCycle
      params.electrical_rate_id = this.state.electricId
      params.discounts = JSON.stringify(this.state.discounts)
    }
    return params
  }

  calculatePrice() {
    if (this.state.arrival && this.state.departure) {
      this.setState({
        loadingPrice: true,
        priceErrorMessage: null,
        billingDisplayText: null,
      })
      $.post(
        $context.manageCalculatePricePath,
        this.calculatePriceParams(),
        (data) => {
          this.setState({
            charges: data.breakdown,
            monthlyCharges: data.monthly_charges,
            monthlyPrice: data.monthly_price,
            totalPrice: data.total_price,
            loadingPrice: false,
            billingDisplayText: data.billing_display_text,
            preservedRates: data.preserved_rates,
          })
        }
      ).fail((data) => {
        const response = parseJSONError(data.responseText)
        this.setState({
          priceErrorMessage:
            response || "There was an error calculating the price.",
          loadingPrice: false,
          billingDisplayText: null,
        })
      })
    } else {
      this.setState({
        loadingPrice: false,
        priceErrorMessage: null,
        billingDisplayText: null,
        totalPrice: 0,
        preservedRates: [],
      })
    }
  }

  promoCodesAvailable() {
    return this.state.promoCodes.length > 0
  }

  addDiscountToForm(params) {
    params._internal_js_id = Math.random()
    this.setState({ discounts: [...this.state.discounts, params] })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  removeDiscount(removeId) {
    this.setState({
      discounts: _.reject(this.state.discounts, { _internal_js_id: removeId }),
    })
    afterSetState(this.updateParent)
    afterSetState(this.calculatePrice)
  }

  setStripeCard(card) {
    // If this is a new card (has an 'id' but not in our list), add it
    // Otherwise, just update the selection
    const existingCard = this.state.userCards.find(
      (c) => c.stripePaymentMethodId === card.stripePaymentMethodId
    )

    if (!existingCard && card.id) {
      // This is a new card, add it to the list
      this.setState({
        userCards: [...this.state.userCards, card],
        selectedCardId: card.stripePaymentMethodId,
      })
    } else {
      // Just update the selection
      this.setState({
        selectedCardId: card.stripePaymentMethodId,
      })
    }
  }

  boatTypeIcon() {
    const classes = "icon text-muted h4 bs-mr-3"
    if (this.props.boat.boatType === "sail") {
      return <i className={`icon-sailboat-thin ${classes}`} />
    } else {
      return <i className={`icon-power-boat-thin ${classes}`} />
    }
  }

  electricSelect() {
    if (this.props.marina.electricOptions.length) {
      return (
        <div>
          <FormGroup
            inputType="select"
            label="Power"
            name="electricId"
            value={
              this.props.savedOrCustomRateApplied ? "" : this.state.electricId
            }
            onChange={this.handleInputChange}
            disabled={this.props.savedOrCustomRateApplied}
          >
            <option value="">None</option>
            {_.map(this.props.marina.electricOptions, (electric) => (
              <option key={electric.id} value={electric.id}>
                {electric.powerType} - {centsToDollars(electric.pricePerNight)}{" "}
                per night
              </option>
            ))}
          </FormGroup>
          {this.props.savedOrCustomRateApplied && (
            <div className="text-muted">
              Configure electric in a custom rate.
            </div>
          )}
        </div>
      )
    }
  }

  submitReservation() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({ loading: true })
      this.createReservation()
    } else {
      this.forceUpdate()
    }
  }

  createReservation() {
    this.setState({ createErrorMessage: null })
    const rateParams = {
      ...this.state.rate,
      amount: dollarsToCents(parseFloat(this.state.rate.amount)),
      taxRate: this.state.rate.taxRate
        ? parseFloat(this.state.rate.taxRate) / 100
        : 0.0,
      feesAndDiscounts: this.state.rate.feesAndDiscounts
        ? JSON.stringify(this.state.rate.feesAndDiscounts)
        : null,
    }
    const params = {
      check_in_date: this.state.arrival,
      check_out_date: this.state.departure,
      requested_space_type: this.state.spaceType,
      special_request: this.state.specialRequest,
      payment_type: this.state.paymentMethod,
      billing_cycle: this.state.billingCycle,
      stripe_card_id: this.cardId(),
      emails_enabled: this.state.confirmationEmail,
      contact_id: this.props.contact.id,
      contact_boat_id: this.props.boat.id,
      waitlist_id: this.props.waitlistId,
      revenue_category_id: this.state.revenueCategoryId,
    }
    if (this.state.promoCode) {
      params.promo_code_id = this.state.promoCode
    }
    if (this.props.savedOrCustomRateApplied) {
      params.rate = _.mapKeys(rateParams, objectKeysToSnakeCase)
      if (this.state.isCustomBillingSet) {
        params.custom_billing = {
          billing_start_date: this.state.customBilling.billingStartDate,
          billing_end_date: this.state.customBilling.billingEndDate,
        }
      }
    } else {
      params.electrical_rate_id = this.state.electricId
      params.discounts = JSON.stringify(this.state.discounts)
    }

    this.fireAmplitudeRevenueCategory()

    $.post($context.createReservationPath, params, (data) => {
      window.location.href = data.new_reservation_url
    }).fail((data) => {
      this.setState({
        createErrorMessage:
          "There was an error creating the reservation. Please try again later or contact support.",
        loading: false,
      })
    })
  }

  cardId() {
    if (this.creditCard()) {
      return this.state.selectedCardId
    }
  }

  creditCard() {
    return this.state.paymentMethod === "credit"
  }

  showCouponCode() {
    this.setState({ showPromoCodes: true })
  }

  isMonthToMonth() {
    return this.state.isCustomBillingSet && this.state.rate.monthToMonth
  }

  savedOrCustomRateApplied() {
    return this.state.isRateApplied || this.state.isCustomBillingSet
  }

  fireAmplitudeRevenueCategory() {
    const revenueCategoryName = this.state.revenueCategoryId
      ? _.mapKeys(this.props.revenueCategories, (o) => o.id)[
          this.state.revenueCategoryId
        ].category
      : "automatic"

    Amplitude.trackEvent("revenue_category_set", {
      revenue_category: revenueCategoryName,
    })
  }

  renderRevenueCategoryChooser() {
    if ($context.revenueCategoriesEnabled) {
      return (
        <div className="row form-row">
          <div className="col-xs-12 col-sm-12">
            <h4 className="bs-mt-0 font-semibold" id="revenueCategory">
              Revenue Category
            </h4>
            <FormGroup
              inputType="select"
              name="revenueCategoryId"
              value={this.state.revenueCategoryId}
              onChange={this.handleInputChangeNoReload}
              ariaLabelledBy="revenueCategory"
            >
              <option key="blank" value="">
                Automatic
              </option>
              {_.map(this.props.revenueCategories, (category) => (
                <option key={category.id} value={category.id}>
                  {category.displayName}
                </option>
              ))}
            </FormGroup>
          </div>
        </div>
      )
    }
  }

  couponCodeSection() {
    if (this.props.savedOrCustomRateApplied) {
      return (
        <div className="bs-mt-2">
          <h4 className="font-semibold">Coupon Code</h4>
          <p className="text-muted">
            Coupon codes do not apply to installment rates. Add discounts to a
            custom rate instead.
          </p>
        </div>
      )
    } else {
      if (this.state.showPromoCodes === true) {
        return (
          <div>
            <div className="bs-mt-2">
              <label>
                {this.promoCodesAvailable()
                  ? "Coupon"
                  : "No Coupons created yet."}
              </label>
              <a
                className="bs-ml-2"
                href={$context.promoCodesPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.promoCodesAvailable()
                  ? "Edit Coupons"
                  : "Create a Coupon"}
              </a>
              {this.promoCodesAvailable() && (
                <div className="form-group">
                  <select
                    className="form-control"
                    onChange={this.handleCouponCode}
                    value={this.state.promoCode}
                    name="promoCode"
                  >
                    <option value={null} />
                    {_.map(this.state.promoCodes, (code) => (
                      <option key={code.id} value={code.id}>
                        {code.discountText}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>
        )
      } else {
        return (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.showCouponCode}
          >
            Add Coupon
          </button>
        )
      }
    }
  }

  render() {
    this.validator.purgeFields()
    return (
      <div className="row form-row">
        <div className="col-sm-8">
          <div className="paper-page bs-p-5">
            <h3 className="bs-mt-0 font-semibold">Itinerary</h3>
            <ItinerarySection
              arrival={this.state.arrival}
              departure={this.state.departure}
              spaceType={this.state.spaceType}
              spaceTypes={
                this.savedOrCustomRateApplied()
                  ? this.props.marina.installmentSpaceTypes
                  : this.props.marina.spaceTypes
              }
              handleInputChange={this.handleInputChange}
              handleArrivalChange={this.handleArrivalChange}
              handleDepartureChange={this.handleDepartureChange}
              disableDepartureDate={this.isMonthToMonth()}
              isTransient={!this.savedOrCustomRateApplied()}
              disabledRevenueCategory
              validator={this.validator}
            />
            <div className="row form-row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Availability</label>
                  <button
                    className="btn btn-secondary w-full"
                    onClick={this.getAvailability}
                    type="button"
                  >
                    {this.state.loadingAvailability ? (
                      <i className="icon icon-spin icon-spinner text-muted bs-mr-2" />
                    ) : null}
                    Check Availability
                  </button>
                </div>
              </div>
              <div className="col-sm-8">{this.electricSelect()}</div>
            </div>
            <FormGroup
              inputType="textarea"
              label="Special Request"
              name="specialRequest"
              value={this.state.specialRequest}
              onChange={this.handleInputChange}
            />
            <hr />
            <PaymentDetailsSection
              billingCycle={this.state.billingCycle}
              paymentMethod={this.state.paymentMethod}
              creditCard={this.creditCard()}
              userCards={this.state.userCards}
              selectedCardId={this.state.selectedCardId}
              handleInputChange={this.handleInputChange}
              handleInputChangeNoReload={this.handleInputChangeNoReload}
              setStripeCard={this.setStripeCard}
              cardCreatePath={buildRoute($context.cardCreatePath, {
                contact_id: this.props.contact.encodedId,
              })}
              billingCycles={this.props.billingCycles}
              validator={this.validator}
              savedOrCustomRateApplied={this.props.savedOrCustomRateApplied}
            />
            <hr />
            <div className="row form-row">
              <div className="col-sm-6">
                <DiscountSection
                  addDiscountToForm={this.addDiscountToForm}
                  discounts={this.state.discounts}
                  removeDiscount={this.removeDiscount}
                  spaceCategory={this.spaceCategory()}
                  disabled={this.props.savedOrCustomRateApplied}
                />
              </div>
              <div className="col-sm-6">
                <h4 className="bs-mt-0 font-semibold">Rates</h4>

                <RateModal
                  isCustomBillingSet={this.state.isCustomBillingSet}
                  isRateApplied={this.state.isRateApplied}
                  rate={this.state.rate}
                  rateType={this.state.rateType}
                  customBilling={this.state.customBilling}
                  rateOptions={this.props.rateOptions}
                  updateParentState={this.updateStateFromRate}
                />
              </div>
            </div>
            <div className="row form-row bs-mt-2">
              <div className="col-sm-6">{this.couponCodeSection()}</div>
              <div className="col-sm-6">
                {this.renderRevenueCategoryChooser()}
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="paper-page bs-p-5">
            <a
              className="h4 text-link-blue font-semibold"
              href={buildRoute($context.contactPath, {
                contact_id: this.props.contact.encodedId,
              })}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.contact.name}
            </a>
            <div>
              {this.boatTypeIcon()}
              {this.props.boat.displayName}
            </div>
            <div>
              <i className="icon icon-nav-mail text-muted h4 bs-mr-3" />
              {this.props.contact.email}
            </div>
            <div>
              <i className="icon icon-phone-btl text-muted h4 bs-mr-3" />
              {this.props.contact.displayPhone}
            </div>
            {this.props.waitlistId && (
              <div className="text-teal-800">
                <i className="icon icon-list h4 bs-mr-3" />
                This boater is getting off the waitlist!
              </div>
            )}
            <PricingSection
              isMonthToMonth={this.isMonthToMonth()}
              charges={this.state.charges}
              monthlyCharges={this.state.monthlyCharges}
              monthlyPrice={this.state.monthlyPrice}
              totalPrice={this.state.totalPrice}
              loadingPrice={this.state.loadingPrice}
              priceErrorMessage={this.state.priceErrorMessage}
              handleInputChange={this.handleInputChangeNoReload}
              confirmationEmail={this.state.confirmationEmail}
              submit={this.submitReservation}
              loading={this.state.loading}
              createErrorMessage={this.state.createErrorMessage}
              billingDisplayText={this.state.billingDisplayText}
              hasTriggerEmails={this.props.hasTriggerEmails}
              preservedRates={this.state.preservedRates}
            />
          </div>
        </div>
        {(this.state.loadingAvailability || this.state.availabilityData) && (
          <div className="col-sm-8">
            <div className="paper-page">
              <h3 className="bs-mt-0 font-semibold">Availability</h3>
              <Availability
                loading={this.state.loadingAvailability}
                data={this.state.availabilityData}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

Summary.propTypes = {
  electricId: PropTypes.string,
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string,
  spaceType: PropTypes.string.isRequired,
  billingCycle: PropTypes.string,
  paymentMethod: PropTypes.string,
  confirmationEmail: PropTypes.bool,
  discounts: PropTypes.array,
  rate: PropTypes.object,
  rateType: PropTypes.string,
  customBilling: PropTypes.object,
  isCustomBillingSet: PropTypes.bool,
  isRateApplied: PropTypes.bool,
  totalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  charges: PropTypes.array,
  revenueCategories: PropTypes.array,
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    encodedId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    displayPhone: PropTypes.string,
  }).isRequired,
  boat: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    boatType: PropTypes.string,
  }).isRequired,
  marina: PropTypes.shape({
    spaceTypes: PropTypes.array.isRequired,
    installmentSpaceTypes: PropTypes.array,
    electricOptions: PropTypes.array,
  }).isRequired,
  billingCycles: PropTypes.array,
  rateOptions: PropTypes.object.isRequired,
  updateParentState: PropTypes.func.isRequired,
  savedOrCustomRateApplied: PropTypes.bool,
  waitlistId: PropTypes.string,
  hasTriggerEmails: PropTypes.bool,
}

export default Summary
